import * as React from "react";
import { Avatar } from "../Avatar/Avatar";
import { Panel, InputGroup, FormControl, Button } from "react-bootstrap";
import styles from "./OnlineList.scss";
import autobind from "autobind-decorator";
import { PresenceStore, AppState, PresenceState } from "../../lib/index";
import { observer, inject } from "mobx-react";
import { observable, action }  from "mobx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faChevronUp, faCheck, faWifi, faClipboard, faChevronDown } from "@fortawesome/fontawesome-pro-light"; //faChevronDown
import * as _ from "lodash";


interface IUserinformation{
	userInformation: IUser;
	me: boolean;
	myNoteFunc: Function;
}

interface IUser{
	dscid: number;
	dscaid: number;
	presence: PresenceState;
	note: string;
	updated: number;
}

interface IOnlineListProps {
	appState?: AppState;
	presenceStore?: PresenceStore;
}



@inject("presenceStore", "appState")
@observer
export class OnlineList extends React.Component <IOnlineListProps, {}>{
	private intervalId;
	constructor(props) {
		super(props);
	}

	@autobind
	private updateStatus (str : string) {
		this.props.presenceStore.myNote = str;
	}

	/**
	 * Swaps loggedin user to the top
	 */
	@autobind
	private getMe() {
		let ret;
		this.props.presenceStore.userPresence.forEach((e, ind : number) => {
			if (this.props.appState.dscaid === e.dscaid) {
				ret = e;
				return;
			}
		});
		if (!ret) {
			// console.error(
			// 	`Error: 'Me' is ${ret}! Couldn't find ${this.props.appState.dscaid} in logged in users!
			// 	'User Online:' is showing a wrong number, because it is using the user online array`
			// );
				ret = {
					dscid: 0,
					dscaid: this.props.appState.dscaid,
					presence: PresenceState.CONNECTION_PROBLEM,
					note: `You are offline`,
					updated: 0,
				};
		}

		return ret;
	}

	public componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	private sort(data : IUser[]) {
		return data.sort((x, y) => {
			if (x.dscaid < y.dscaid) return -1;
			if (x.dscaid > y.dscaid) return 1;
			return 0;
		});
	}

	@autobind
	private getUsersOnline() {
		return this.props.presenceStore.userPresence.size;
	}

	public render() {
		//create proper json for looping
		let projectsObjects : any = {};
		this.props.presenceStore.userPresence.forEach(e => {
			if (projectsObjects[e.dscid] == null) {
				projectsObjects[e.dscid] = {
					dscid: e.dscid,
					onlineUsers: [],
				};
			}
			projectsObjects[e.dscid].onlineUsers.push(e);
		});
		let projects = _.values(projectsObjects);
		projects.forEach(e => {
			this.sort(e.onlineUsers);
		});

		return(
			<div style={{ display: "flex", flexFlow: "column", height: "100%"}}>
				<div style={{ flex: "1", minHeight: 0, overflow: "auto" }}>
				<span
					className = {`label label-primary ${styles.projectName}`}
					style = {{display: "block"}}
				>
					<FontAwesomeIcon
						className = "pull-right"
						style = {{float: "right"}}
						icon={faWifi}
					/>
					User Online: {this.getUsersOnline()}
				</span>
				{this.getMe() &&
					<User userInformation = {this.getMe()} me = {true} myNoteFunc = {this.updateStatus}/>
				}
				{projects.map((project) =>
					<div key={project.dscid}>
						{projects.length > 1 &&
							<span className = {`label label-primary ${styles.projectName}`}>
								{project.dscid}
							</span>
						}
						{project.onlineUsers.map((user : IUser) => {
							return !(user.dscaid === this.props.appState.dscaid) && <User key={user.dscaid} userInformation={user} me={false} myNoteFunc = {this.updateStatus}/>;
						})
						}
					</div>
				)}
				{(this.getUsersOnline() <= 1 || this.getMe().dsaid === 0) && <div className = {`${styles.noUserOnline}`}>No user online</div>}
				</div>
			</div>
		);
	}
}


@observer class User extends React.Component<IUserinformation, any>{
	@observable private open : boolean = false;
	constructor(props) {
		super(props);
	}

	private isMe(dscaid : number) : boolean {
		return this.props.me;
	}


	@action private expand() : void {
		this.open = !this.open;
	}


	private openProfile() {
		dsloader(
			`dynasite.cfm?dscmd=contact_contact_contact_detail&dscaid=${this.props.userInformation.dscaid}`,
			"tab",
			`contact_contact_contact_detail_${this.props.userInformation.dscaid}`,
			"xhr:1"
		);
	}

	public render() {
		return(//is me? yes then this style if not use default style
			<div>
				{this.isMe(this.props.userInformation.dscaid) ?
				<div style = {{textAlign: "center"}}>
					<div style = {{padding: "5px 0 0 0"}} className = {styles.centerAvatar}>
						<span onClick= {() => this.expand()} className = {` ${styles.buttonDown}`} style = {{padding: "5px"}}>
							<Avatar
								url = ""
								size = {50}
								dscaid =
									{this.props.userInformation.dscid ?
										this.props.userInformation.dscaid :
										0
									}
							/>
						</span>
					</div>
						<a href="javascript:void(0)" onClick = {e => {e.stopPropagation(); this.openProfile(); }}>
							{this.props.userInformation.dscaid /*change later to name*/}
						</a>
						<br/>
						<span className = {styles.description} style = {{paddingBottom: "8px", marginTop: "-15px"}}>
							<Userstatus
								status = {this.props.userInformation.note}
								isMe = {this.isMe(this.props.userInformation.dscaid)}
								statusFunc = {this.props.myNoteFunc}
							/>
						</span>
				</div> :
				<div className={`list-group-item list-group-item-action ${styles.noBorder}`} style = { {display: "flex", flexFlow: "row", padding: "8px 0 0 15px"}}>
					<div style = {{ flex: "0 0 auto", padding: "3px 0"}}>
						<Avatar url = "" size = {37} dscaid = {this.props.userInformation.dscid ? this.props.userInformation.dscaid : 0}/>
					</div>
					<div style = {{flex: "1", paddingTop: "3px", paddingLeft: "6px"}}>
						<span className = {`${styles.buttonDown} ${styles.buttonOnRight}`} onClick= {() => this.expand()}>
							<FontAwesomeIcon key={this.open ? "x" : "y"} icon={this.open ? faChevronUp : faChevronDown }/>
							{/*
								pr:
								This is not the best way of solving the problem. Somehow this icon does not
								behave like it should. Swaping the key makes react see that the icon is changed and swaps out the entire <FontAwesomeIcon>.
								 The first workaround using css does not work anymore.
								This should be changed when we found a better way. (Todo)
							*/}
						</span>
						<span className = {styles.description}>
							<a href="javascript:void(0)" onClick = {e => {e.stopPropagation(); this.openProfile(); }}>
								{this.props.userInformation.dscaid}
							</a>
							<br/>
							<Userstatus
								status = {this.props.userInformation.note}
								isMe = {this.isMe(this.props.userInformation.dscaid)}
								statusFunc = {this.props.myNoteFunc}
							/>
						</span>
					</div>
				</div>
				}
				<Panel
					collapsible
					expanded ={this.open}
					style = {{
						padding: "0 15px " + `${this.props.me ? "0" : "10px"} 0`,
						margin: "0",
						borderTop: `${!this.open && this.props.me ? "none" : "1px solid #ddd"}`
					}}/*!!!!!*/
				>
				<div style = {{padding : "0"}}>
					{!(this.props.me) &&
						<hr className = {styles.hrUser}/>
					} {/*!!!!!*/}
						<table>
							<tbody className = {styles.userdetails}>
								<tr>
									<td>
										Mobile:
									</td>
									<td>
										<a href={`tel:`}>{this.props.userInformation.dscaid}</a>
									</td>
									<td>
										<span
											onClick = {() => this.copyTextToClipboard(`${this.props.userInformation.dscid}`)}
											className = {styles.clipboard}
										>
											<FontAwesomeIcon icon={faClipboard}/>
										</span>
									</td>
								</tr>
								<tr>
									<td>
										Phone:
									</td>
									<td>
										<a href={`tel:`}>{this.props.userInformation.dscaid}</a>
									</td>
									<td>
										<span
											onClick = {() => this.copyTextToClipboard(`${this.props.userInformation.dscid}`)}
											className = {styles.clipboard}
										>
											<FontAwesomeIcon icon={faClipboard}/>
										</span>
									</td>
								</tr>
								<tr>
									<td>
										Mail:
									</td>
									<td>
										<a href={`mailto:`}>{this.props.userInformation.dscaid}</a>
									</td>
									<td>
										<span
											onClick = {() => this.copyTextToClipboard(`${this.props.userInformation.dscid}`)}
											className = {styles.clipboard}
										>
											<FontAwesomeIcon icon={faClipboard}/>
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</Panel>
			</div>
		);
	}


	private copyTextToClipboard(text : string) : void {
		let textArea = document.createElement("textarea");
		textArea.style.background = "transparent";
		textArea.value = text;
		document.body.appendChild(textArea);
		textArea.select();
		try {
			document.execCommand("copy");
		} catch (err) {
			alert("Something went wrong (Failed to copy)");
		}
		document.body.removeChild(textArea);
	}

}


@observer class Userstatus extends React.Component<any, any>{
	@observable private status: string;
	@observable private editmode: boolean = false;

	constructor(props) {
		super(props);
		this.status = this.props.status;
		// console.log(this.props.isMe);
	}

	@autobind @action private onChangeStatus(e) : void {
		this.status = e.target.value;
	}

	@autobind
	private switchEditmode(e) : void {
		e.stopPropagation();
		if (this.props.isMe) {
			this.editmode = !this.editmode;
		}
	}

	private saveChanges(e) : void {
		this.props.statusFunc(this.status);
		this.switchEditmode(e);
	}

	//-> impl save method that changes the Profile_Message global

	public render() {
		return (
			this.editmode ?
			<InputGroup bsSize = "small" style = {{width: "120px"}}>
				<FormControl
					onChange = {(e) => this.onChangeStatus(e)}
					type = "text"
					placeholder = "max 30 signs..."
					value = {this.status}
					onKeyDown = {(e) => {
						if (e.keyCode === 13) { //13 -> Enter-Key
							this.saveChanges(e);
						}
					}}
					style = {{height: "25px"}}
					maxLength = {30}

				/>
				<InputGroup.Button>
					<Button
						style = {{height: "25px", padding: "0 8px 0 8px"}}
						onClick = {(e) => this.saveChanges(e)}
						bsStyle = "success"
					>
						<FontAwesomeIcon icon={faCheck}/>
					</Button>
				</InputGroup.Button>
			</InputGroup>
			:
			this.status ?
			<p className = {styles.status}
				onClick = {(e) =>
					this.switchEditmode(e)}
			>
				{this.status}
			</p> :
			<p className = {styles.status}
				onClick = {(e) =>
					this.switchEditmode(e)}
			>
				<i className = {this.props.isMe ? styles.noStatus : styles.status}>
					{this.props.isMe ? "Click to set status" : "Online"}
				</i>
			</p>
		);
	}

}




// WEBPACK FOOTER //
// ./src/common/OnlineList/OnlineList.tsx